import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'error-404-page',
	imports: [
	],
	templateUrl: './error-404.page.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: `
	dashboard-scrollable-content {
		.error-404 {
			text-align: center;
			color: darkred;
			margin-top: 3em;
		}
	}
	`
})
export class DashboardError404Page {
}
